module.exports = __webpack_public_path__ + "img/umana.4484c808.png";